<template>
  <div>
    <notifications />
    <div v-if="$store.state.logged" class="fadeIn">
      
      <header>
        <div class="row" style="width: 100%;">
          <div class="col-sm-11 col-md-3 col-xl-2 pl-1">
            <img src="./assets/gw-logo.png" alt="GroundWorx logo" class="logo">
          </div>
          <div class="col-md-9 col-xl-10 hide-for-mobile" style="display: inline-flex; padding-right: 0px;">
            <div class="select courses-select">
              <template>
                <multiselect v-model="courseSelected"
                  class="multiselect-golf-courses"
                  :multiple="false"
                  track-by="course_id"
                  :placeholder="$t('general.searchFacility')"
                  :preselect-first="false"
                  :showLabels="false"
                  :allow-empty="false"
                  :options="getCoursesGrouped"
                  @select="onChangeGolfCourse"
                  label="name"
                  group-values="courses" 
                  group-label="country" 
                  :group-select="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div class="option__desc"><span class="option__title">{{ option.name }}</span></div>
                  </template>
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc"><span class="option__title">{{ option.$isLabel ? option.$groupLabel : option.name }}</span></div>
                  </template>
                  <span slot="noResult">{{ $t('general.noFacilityMatch') }}</span>
                </multiselect>
              </template>
              <img :src="courseSelected.logo_url" class="logo">
            </div>

            <div class="user-container">
              <div class="d-flex justify-content-end">
                <span class="my-auto">{{ $t('general.welcome') }}, {{user.name}}</span>
                <Messages />
                <News />

                <GwLanguage class="ml-0"/>
                
                <UserAvatar :user="user" :includeUnassignedTxt="false" />
                <div class="logout btn " v-on:click="signOut">
                  <img src="@/assets/img/ic/ico_shutdown.png">
                  {{ $t('settings.logOut') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-1 hide-for-desktop">
            <i @click="toggleMenu" class="fa fa-bars ic-hamburger-menu"></i>
          </div>
        </div>

      </header>
      
      <div class="container-fuid">
        <div class="row">
          <aside ref="gwSidebar" class="col-md-3 col-xl-2 gw-sidebar">
            <div class="nav">

              <div class="courses-select hide-for-desktop">
                <span class="fz-text-details">{{ $t('general.welcome') }} {{user.name}}. {{ $t('dashboard.yourCourses') }}:</span>
                <div class="select">
                  <b-form-select v-model="courseSelected" :options="courses" @change="()=>{
                    this.toggleMenu();
                    this.onChangeGolfCourse();
                  }" class="select-golf-courses" />
                </div>
              </div>

              <ul>
                <li @click="toggleMenu" v-for="menuOption in this.$store.state.menuPolicy" :key="menuOption.title">
                  <router-link :to="{ path: menuOption.uri }">
                    <div class="menu-item">
                      <div>
                        <template v-if="menuOption.icon.startsWith('asset')">
                          <img :src="require(`@/assets/img/menu/${menuOption.icon}`)" :class="`img-menu ${menuOption.vue_component}`" />
                        </template>
                        <i v-else-if="giveChars(menuOption.icon) === 'fa-'" class="fa" v-bind:class="menuOption.icon" />
                        <i class="material-icons" v-else>
                          {{menuOption.icon}}
                        </i>
                      </div>
                      <div>
                        <span>{{ $t(menuOption.i18n) }}</span>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="gw-sidebar-footer hide-for-desktop">
              <div class="logout btn btn-light" v-on:click="signOut">{{ $t('settings.logOut') }}</div>
            </div>
          </aside>
          <main class="gw-content col-md-9 col-xl-10 py-md-3 pl-md-4 gw-content" role="main">
            <article class="container-fluid">
              <router-view />
            </article>
          </main>
        </div>
      </div>
    </div>
    <div v-else class="body-login">
      <router-view />
    </div>
    <div id="bg-image"></div>
  </div>
</template>

<script type="text/javascript">
  import { Loader } from 'google-maps';
  import { isEmpty } from 'lodash';
  import UserAvatar from '@/components/user/avatar/UserAvatar.vue';
  import Messages from '@/components/messages/Messages.vue';
  import GwLanguage from '@/components/language/GwLanguage.vue';
  import Multiselect from 'vue-multiselect'
  import News from '@/components/news/News.vue';

  import { mapState, mapActions } from 'vuex';
  
  const mapLoader = new Loader(process.env.VUE_APP_KEY_GOOGLE_MAP, {
    libraries: ['places']
  });

  export default {
    name: 'App',
    components: {
      UserAvatar,
      Messages,
      GwLanguage,
      Multiselect,
      News,
    },
    data() {
      return {
        tempBgIndex: 0,
      };
    },
    methods: {
      giveChars(str) {
        return str.slice(0, 3);
      },
      signed() {
        if (!isEmpty(this.user)) {
          this.$store.state.logged = true;
          if(process.env.VUE_APP_SENTRY_ENV == "production"){
            this.$analytics.setUserId(this.user.user_id);
            this.$analytics.setUserProperties({
              userType: this.user.user_type
            })
          }

          if (isEmpty(this.courseSelected)) {
            this.courseSelected = {
              ...this.courses[1].value
            };
          }
        }
      },

      async signOut() {
        this.G_signout();
      },
      
      toggleMenu() {
        if (this.$refs.gwSidebar.classList.contains('show')) {
          this.$refs.gwSidebar.classList.remove('show');
        } else {
          this.$refs.gwSidebar.classList.add('show');
        }
      },

      onChangeGolfCourse() {
        window.location.reload(false);
      },

      ...mapActions(['changeBackground']),
    },
    beforeMount() {
      this.consts.Google.MAP_LOADER = mapLoader;
      this.signed();
      setInterval(() => {
        this.changeBackground();
      }, process.env.VUE_APP_REFRESH_BG_MS);
    },
    mounted() {
      this.changeBackground();
    },

    beforeUpdate() {
      if (!isEmpty(this.user)) {
        this.$store.state.logged = true;
      }
      this.signed();
    },
    computed: {
      getCoursesGrouped() {
        let gruopedFacilities = []
        for(let i = 0; i < this.courses.length; i++){
          let facility = this.courses[i];
          if(facility.value){
            let data = facility.value;
            let group = data.country_code ? data.country_code.toLowerCase() : 'other';

            let idx = gruopedFacilities.findIndex(item => item.country_code == group);

            if(idx >= 0){
              let groupData = gruopedFacilities[idx];
              groupData.courses.push(data);
              
            }else{
              let groupData = {
                'country': this.$t('country_code.'+group),
                'country_code': group,
                'courses': [data]
              }
              gruopedFacilities.push(groupData);
            }

          }
        }
        
        let sortedFacilities = gruopedFacilities.sort(function(a, b) {
          var nameA = a.country.toUpperCase(); // ignore upper and lowercase
          var nameB = b.country.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });

        return sortedFacilities;
      },
      user() {
        return this.$store.state.user;
      },
      courseSelected: {
        get() {
          return this.courseStore;
        },
        set(value) {
          let menu =  [...this.$store.state.fullMenu];
          if(menu && menu.length > 0){
            this.$store.commit(
              "setMenuPolicy",
              menu.sort(function (a, b) {
                return a.orden == b.orden ? 0 : a.orden > b.orden ? 1 : -1;
              })
            );

            let idx = menu.findIndex(item => item.name == 'Holes');

            if(idx > 0 && value.facility_type && !value.facility_type.is_golf_course){
              menu[idx].i18n = 'zones.zones';
            }else{
              menu[idx].i18n = 'holes.holes';
            }

            idx = menu.findIndex(item => (item.name == 'Course View' || item.name == 'Course'));
            if(idx > 0 && value.facility_type && !value.facility_type.is_golf_course){
              menu.splice(idx, 1);
            }

            idx = menu.findIndex(item => item.name == 'Facility View');
            if(idx > 0 && value.facility_type && value.facility_type.is_golf_course){
              menu.splice(idx, 1);
            }
          }

          this.$store.commit('setCourse', value);
        },
      },
      courses () {
        let courseList = [{ value: null, text: this.$t('facility.selectFacility'), selected: true }];
        courseList = courseList.concat(this.userCourses.map((course) => ({
              value: course,
              text: course.name,
            })));
        return courseList;
      },
      ...mapState({
        userCourses: (state) => state.userCourses,
        courseStore: (state) => state.course,
      }),
    },
    watch: {
      courseSelected(val) {
        this.$emit('courseChange', val);
      },
    },
  };

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import './assets/styles/app.scss';
  @import './assets/styles/buttons.scss';

  #bg-image {
    top: 0;
    z-index: -1;
    position: absolute;
    height: 100vh;
    width: 100vw;
    background-size: cover;
    background-repeat: no-repeat;
  }

  @keyframes bg-fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .bg-fadeIn {
    animation-name: bg-fadeIn;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-duration: 2s;
    animation-direction: alternate;
  }

  @keyframes bg-fadeOut {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .bg-fadeOut {
    animation-name: bg-fadeOut;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-duration: 2s;
    animation-direction: alternate;
  }

  .menu-item {
    display: inline-flex;
    
    div:first-child {
      width: 35px;
      text-align: center;
    }

    .img-menu {
      height: 24px !important;
      margin-right: 5px;
    }
    .Stations {
      height: 28px !important;
      margin-top: -3px;
    }

  }

  

  .multiselect-golf-courses {
    height: 40px !important;
  }
  
  .multiselect-golf-courses .multiselect__placeholder {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1;
    color: #495057;
  }

  .multiselect-golf-courses .multiselect__tags{
    margin-right: 15px;
    margin-left: 10px;
    padding-left: 0px;
    border: none;
    border-radius: 40px;
  }

  .multiselect-golf-courses .multiselect__select:before{
    color: #343a40 !important;
    border-color: #343a40 transparent transparent;
  }

  .multiselect-golf-courses .multiselect__content-wrapper{
    width: auto !important;
    overflow-x: hidden;
    border: 1px solid #ccc;
  }

  .multiselect-golf-courses .multiselect__single, .multiselect-golf-courses .multiselect__input{
    max-height: 24px;
    overflow: hidden;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .multiselect-golf-courses .option__desc{
    width: 100% !important;
    overflow: hidden;
    flex-wrap: nowrap;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .multiselect-golf-courses .multiselect__option--group{
    padding-left: 5px !important;
    color: #666;
  }

</style>
